var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"button",class:{
               'button--bordered': _vm.bordered,
               'button--accent': _vm.accent,
               'button--link': _vm.isLink,
               'button--fill': _vm.isFill,
               'button--disable': _vm.isDisabled
            },attrs:{"to":_vm.to},on:{"click":_vm.handleClick}},[(_vm.icon)?_c('base-icon',{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default",[_c('span',[_vm._v(" "+_vm._s(_vm.value)+" ")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }